/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {EnrichedInputResponse} from '../bioplanModels';
// @ts-ignore
import type {InputPatch} from '../bioplanModels';
// @ts-ignore
import type {InputPost} from '../bioplanModels';
// @ts-ignore
import type {InputPut} from '../bioplanModels';
// @ts-ignore
import type {SimpleInputResponse} from '../bioplanModels';
/**
 * PlanningInputApi - axios parameter creator
 * @export
 */
export const PlanningInputApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create input for a cage
     * @param {Array<InputPost>} inputPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inputsBatchPost: async (inputPost: Array<InputPost>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'inputPost' is not null or undefined
      assertParamExists('inputsBatchPost', 'inputPost', inputPost);
      const localVarPath = `/inputs/batch`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(inputPost, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all input actions for a cage
     * @param {string} planId
     * @param {string} [cageId]
     * @param {string} [siteId]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {Array<string>} [smoltSupplyIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inputsGet: async (
      planId: string,
      cageId?: string,
      siteId?: string,
      startDate?: string,
      endDate?: string,
      smoltSupplyIds?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('inputsGet', 'planId', planId);
      const localVarPath = `/inputs/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      if (cageId !== undefined) {
        localVarQueryParameter['cageId'] = cageId;
      }

      if (siteId !== undefined) {
        localVarQueryParameter['siteId'] = siteId;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      if (smoltSupplyIds) {
        localVarQueryParameter['smoltSupplyIds'] = smoltSupplyIds;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete input by its identifier
     * @param {string} inputId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inputsInputIdDelete: async (
      inputId: string,
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'inputId' is not null or undefined
      assertParamExists('inputsInputIdDelete', 'inputId', inputId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('inputsInputIdDelete', 'planId', planId);
      const localVarPath = `/inputs/{inputId}`.replace(`{${'inputId'}}`, encodeURIComponent(String(inputId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get input by its identifier
     * @param {string} inputId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inputsInputIdGet: async (
      inputId: string,
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'inputId' is not null or undefined
      assertParamExists('inputsInputIdGet', 'inputId', inputId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('inputsInputIdGet', 'planId', planId);
      const localVarPath = `/inputs/{inputId}`.replace(`{${'inputId'}}`, encodeURIComponent(String(inputId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update input for a cage
     * @param {string} inputId
     * @param {InputPatch} inputPatch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inputsInputIdPatch: async (
      inputId: string,
      inputPatch: InputPatch,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'inputId' is not null or undefined
      assertParamExists('inputsInputIdPatch', 'inputId', inputId);
      // verify required parameter 'inputPatch' is not null or undefined
      assertParamExists('inputsInputIdPatch', 'inputPatch', inputPatch);
      const localVarPath = `/inputs/{inputId}`.replace(`{${'inputId'}}`, encodeURIComponent(String(inputId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PATCH', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(inputPatch, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inputsNotLinkedToSmoltSuppliesGet: async (
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('inputsNotLinkedToSmoltSuppliesGet', 'planId', planId);
      const localVarPath = `/inputs/notLinkedToSmoltSupplies`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create input for a cage
     * @param {InputPost} inputPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inputsPost: async (inputPost: InputPost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'inputPost' is not null or undefined
      assertParamExists('inputsPost', 'inputPost', inputPost);
      const localVarPath = `/inputs/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(inputPost, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Batch update inputs
     * @param {Array<InputPut>} inputPut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inputsPut: async (inputPut: Array<InputPut>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'inputPut' is not null or undefined
      assertParamExists('inputsPut', 'inputPut', inputPut);
      const localVarPath = `/inputs/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(inputPut, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningInputApi - functional programming interface
 * @export
 */
export const PlanningInputApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningInputApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create input for a cage
     * @param {Array<InputPost>} inputPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inputsBatchPost(
      inputPost: Array<InputPost>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimpleInputResponse>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inputsBatchPost(inputPost, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningInputApi.inputsBatchPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all input actions for a cage
     * @param {string} planId
     * @param {string} [cageId]
     * @param {string} [siteId]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {Array<string>} [smoltSupplyIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inputsGet(
      planId: string,
      cageId?: string,
      siteId?: string,
      startDate?: string,
      endDate?: string,
      smoltSupplyIds?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnrichedInputResponse>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inputsGet(
        planId,
        cageId,
        siteId,
        startDate,
        endDate,
        smoltSupplyIds,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningInputApi.inputsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete input by its identifier
     * @param {string} inputId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inputsInputIdDelete(
      inputId: string,
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inputsInputIdDelete(inputId, planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningInputApi.inputsInputIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get input by its identifier
     * @param {string} inputId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inputsInputIdGet(
      inputId: string,
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnrichedInputResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inputsInputIdGet(inputId, planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningInputApi.inputsInputIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update input for a cage
     * @param {string} inputId
     * @param {InputPatch} inputPatch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inputsInputIdPatch(
      inputId: string,
      inputPatch: InputPatch,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleInputResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inputsInputIdPatch(inputId, inputPatch, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningInputApi.inputsInputIdPatch']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inputsNotLinkedToSmoltSuppliesGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnrichedInputResponse>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inputsNotLinkedToSmoltSuppliesGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningInputApi.inputsNotLinkedToSmoltSuppliesGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create input for a cage
     * @param {InputPost} inputPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inputsPost(
      inputPost: InputPost,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleInputResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inputsPost(inputPost, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningInputApi.inputsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Batch update inputs
     * @param {Array<InputPut>} inputPut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inputsPut(
      inputPut: Array<InputPut>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimpleInputResponse>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inputsPut(inputPut, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningInputApi.inputsPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningInputApi - factory interface
 * @export
 */
export const PlanningInputApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningInputApiFp(configuration);
  return {
    /**
     *
     * @summary Create input for a cage
     * @param {PlanningInputApiInputsBatchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inputsBatchPost(
      requestParameters: PlanningInputApiInputsBatchPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<SimpleInputResponse>> {
      return localVarFp
        .inputsBatchPost(requestParameters.inputPost, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all input actions for a cage
     * @param {PlanningInputApiInputsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inputsGet(
      requestParameters: PlanningInputApiInputsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<EnrichedInputResponse>> {
      return localVarFp
        .inputsGet(
          requestParameters.planId,
          requestParameters.cageId,
          requestParameters.siteId,
          requestParameters.startDate,
          requestParameters.endDate,
          requestParameters.smoltSupplyIds,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete input by its identifier
     * @param {PlanningInputApiInputsInputIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inputsInputIdDelete(
      requestParameters: PlanningInputApiInputsInputIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .inputsInputIdDelete(requestParameters.inputId, requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get input by its identifier
     * @param {PlanningInputApiInputsInputIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inputsInputIdGet(
      requestParameters: PlanningInputApiInputsInputIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<EnrichedInputResponse> {
      return localVarFp
        .inputsInputIdGet(requestParameters.inputId, requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update input for a cage
     * @param {PlanningInputApiInputsInputIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inputsInputIdPatch(
      requestParameters: PlanningInputApiInputsInputIdPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SimpleInputResponse> {
      return localVarFp
        .inputsInputIdPatch(requestParameters.inputId, requestParameters.inputPatch, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {PlanningInputApiInputsNotLinkedToSmoltSuppliesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inputsNotLinkedToSmoltSuppliesGet(
      requestParameters: PlanningInputApiInputsNotLinkedToSmoltSuppliesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<EnrichedInputResponse>> {
      return localVarFp
        .inputsNotLinkedToSmoltSuppliesGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create input for a cage
     * @param {PlanningInputApiInputsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inputsPost(
      requestParameters: PlanningInputApiInputsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SimpleInputResponse> {
      return localVarFp.inputsPost(requestParameters.inputPost, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Batch update inputs
     * @param {PlanningInputApiInputsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inputsPut(
      requestParameters: PlanningInputApiInputsPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<SimpleInputResponse>> {
      return localVarFp.inputsPut(requestParameters.inputPut, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for inputsBatchPost operation in PlanningInputApi.
 * @export
 * @interface PlanningInputApiInputsBatchPostRequest
 */
export interface PlanningInputApiInputsBatchPostRequest {
  /**
   *
   * @type {Array<InputPost>}
   * @memberof PlanningInputApiInputsBatchPost
   */
  readonly inputPost: Array<InputPost>;
}

/**
 * Request parameters for inputsGet operation in PlanningInputApi.
 * @export
 * @interface PlanningInputApiInputsGetRequest
 */
export interface PlanningInputApiInputsGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningInputApiInputsGet
   */
  readonly planId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningInputApiInputsGet
   */
  readonly cageId?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningInputApiInputsGet
   */
  readonly siteId?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningInputApiInputsGet
   */
  readonly startDate?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningInputApiInputsGet
   */
  readonly endDate?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof PlanningInputApiInputsGet
   */
  readonly smoltSupplyIds?: Array<string>;
}

/**
 * Request parameters for inputsInputIdDelete operation in PlanningInputApi.
 * @export
 * @interface PlanningInputApiInputsInputIdDeleteRequest
 */
export interface PlanningInputApiInputsInputIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningInputApiInputsInputIdDelete
   */
  readonly inputId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningInputApiInputsInputIdDelete
   */
  readonly planId: string;
}

/**
 * Request parameters for inputsInputIdGet operation in PlanningInputApi.
 * @export
 * @interface PlanningInputApiInputsInputIdGetRequest
 */
export interface PlanningInputApiInputsInputIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningInputApiInputsInputIdGet
   */
  readonly inputId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningInputApiInputsInputIdGet
   */
  readonly planId: string;
}

/**
 * Request parameters for inputsInputIdPatch operation in PlanningInputApi.
 * @export
 * @interface PlanningInputApiInputsInputIdPatchRequest
 */
export interface PlanningInputApiInputsInputIdPatchRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningInputApiInputsInputIdPatch
   */
  readonly inputId: string;

  /**
   *
   * @type {InputPatch}
   * @memberof PlanningInputApiInputsInputIdPatch
   */
  readonly inputPatch: InputPatch;
}

/**
 * Request parameters for inputsNotLinkedToSmoltSuppliesGet operation in PlanningInputApi.
 * @export
 * @interface PlanningInputApiInputsNotLinkedToSmoltSuppliesGetRequest
 */
export interface PlanningInputApiInputsNotLinkedToSmoltSuppliesGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningInputApiInputsNotLinkedToSmoltSuppliesGet
   */
  readonly planId: string;
}

/**
 * Request parameters for inputsPost operation in PlanningInputApi.
 * @export
 * @interface PlanningInputApiInputsPostRequest
 */
export interface PlanningInputApiInputsPostRequest {
  /**
   *
   * @type {InputPost}
   * @memberof PlanningInputApiInputsPost
   */
  readonly inputPost: InputPost;
}

/**
 * Request parameters for inputsPut operation in PlanningInputApi.
 * @export
 * @interface PlanningInputApiInputsPutRequest
 */
export interface PlanningInputApiInputsPutRequest {
  /**
   *
   * @type {Array<InputPut>}
   * @memberof PlanningInputApiInputsPut
   */
  readonly inputPut: Array<InputPut>;
}

/**
 * PlanningInputApi - object-oriented interface
 * @export
 * @class PlanningInputApi
 * @extends {BaseAPI}
 */
export class PlanningInputApi extends BaseAPI {
  /**
   *
   * @summary Create input for a cage
   * @param {PlanningInputApiInputsBatchPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningInputApi
   */
  public inputsBatchPost(requestParameters: PlanningInputApiInputsBatchPostRequest, options?: RawAxiosRequestConfig) {
    return PlanningInputApiFp(this.configuration)
      .inputsBatchPost(requestParameters.inputPost, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all input actions for a cage
   * @param {PlanningInputApiInputsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningInputApi
   */
  public inputsGet(requestParameters: PlanningInputApiInputsGetRequest, options?: RawAxiosRequestConfig) {
    return PlanningInputApiFp(this.configuration)
      .inputsGet(
        requestParameters.planId,
        requestParameters.cageId,
        requestParameters.siteId,
        requestParameters.startDate,
        requestParameters.endDate,
        requestParameters.smoltSupplyIds,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete input by its identifier
   * @param {PlanningInputApiInputsInputIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningInputApi
   */
  public inputsInputIdDelete(
    requestParameters: PlanningInputApiInputsInputIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningInputApiFp(this.configuration)
      .inputsInputIdDelete(requestParameters.inputId, requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get input by its identifier
   * @param {PlanningInputApiInputsInputIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningInputApi
   */
  public inputsInputIdGet(requestParameters: PlanningInputApiInputsInputIdGetRequest, options?: RawAxiosRequestConfig) {
    return PlanningInputApiFp(this.configuration)
      .inputsInputIdGet(requestParameters.inputId, requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update input for a cage
   * @param {PlanningInputApiInputsInputIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningInputApi
   */
  public inputsInputIdPatch(
    requestParameters: PlanningInputApiInputsInputIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningInputApiFp(this.configuration)
      .inputsInputIdPatch(requestParameters.inputId, requestParameters.inputPatch, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PlanningInputApiInputsNotLinkedToSmoltSuppliesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningInputApi
   */
  public inputsNotLinkedToSmoltSuppliesGet(
    requestParameters: PlanningInputApiInputsNotLinkedToSmoltSuppliesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningInputApiFp(this.configuration)
      .inputsNotLinkedToSmoltSuppliesGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create input for a cage
   * @param {PlanningInputApiInputsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningInputApi
   */
  public inputsPost(requestParameters: PlanningInputApiInputsPostRequest, options?: RawAxiosRequestConfig) {
    return PlanningInputApiFp(this.configuration)
      .inputsPost(requestParameters.inputPost, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Batch update inputs
   * @param {PlanningInputApiInputsPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningInputApi
   */
  public inputsPut(requestParameters: PlanningInputApiInputsPutRequest, options?: RawAxiosRequestConfig) {
    return PlanningInputApiFp(this.configuration)
      .inputsPut(requestParameters.inputPut, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
